import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/core/_config/app.config';
import { ApiServiceExtension } from 'src/app/core/extension/apiServiceExtension';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PixResultsService extends ApiServiceExtension {
    constructor(protected config: AppConfig, public http: HttpClient) {
        super(config, http);
    }

    public GetByFilter(
        entityId: string,
        status: number,
        beginDate: Date,
        endDate: Date,
        isNegotiation: boolean,
    ): Observable<any> {
        let url = `${
            this.API_URL
        }PixResults/?entityId=${entityId}&status=${status}&beginDate=${beginDate.toISOString()}&endDate=${endDate.toISOString()}&isNegotiation=${isNegotiation}`;
        return this.http.get(url);
    }

    public ResendPix(params: any): Observable<any> {
        return this.http.post<any>(`${this.API_URL}PixResults/ResendPix`, params);
    }

    public PermissionResendPix(username: string): Observable<any> {
        return this.http.get<any>(`${this.API_URL}PixResults/PermissionResendPix/${username}`);
    }

    public AnotherBillets(billetId: string, paymentDate: Date): Observable<any> {
        return this.http.get<any>(`${this.API_URL}PixResults/GetAnotherBillets/${billetId}/${paymentDate}`);
    }

    public ChangeBilletFromPixResult(id: string, billetsRetryToPay: any): Observable<any> {
        let params = { id, billetsRetryToPay };
        return this.http.put(`${this.API_URL}PixResults/ChangeBilletFromPixResult`, params);
    }
    public UpdatePixStatus(id: string, status: number, description: string): Observable<any> {
        let body = { id, status, description };
        return this.http.put<any>(`${this.API_URL}PixResults/UpdatePixStatus`, body);
    }
}
